import { Alert } from '@/v2/plugins/alert';
import { callFirebaseFunction } from '@/v2/utils/firebase';
import { t } from '@/locales';

export const MyFatoorahInvoiceStatus = Object.freeze({
	Pending: 'Pending',
	Paid: 'Paid',
	Canceled: 'Canceled',
	Refunded: 'Refunded',
	Expired: 'Expired',
});

export const MyFatoorahInvoiceStatusOptions = () => [
	{ label: t('e-agent.MyFatoorahInvoiceStatus.Paid'), value: MyFatoorahInvoiceStatus.Paid },
	{ label: t('e-agent.MyFatoorahInvoiceStatus.Pending'), value: MyFatoorahInvoiceStatus.Pending },
	{
		label: t('e-agent.MyFatoorahInvoiceStatus.Canceled'),
		value: MyFatoorahInvoiceStatus.Canceled,
	},
	{
		label: t('e-agent.MyFatoorahInvoiceStatus.Expired'),
		value: MyFatoorahInvoiceStatus.Expired,
	},
];

export const MyFatoorahDepositStatus = Object.freeze({
	Deposited: 'Deposited',
	NotDeposited: 'Not Deposited',
});

export class MyFatoorah {
	static async getMyFatoorahBanksOptions(qp = { items_per_page: 1000 }) {
		try {
			const result = await callFirebaseFunction(
				'myFatoorahGetBanks',
				{ queryParams: qp },
				{ method: 'get' },
			);
			return result || [];
		} catch (err) {
			const msg = err?.message || 'Error fetching banks';
			Alert.error(msg);
			console.error(err);
			throw err;
		}
	}

	static async createSupplier(data) {
		try {
			const result = await callFirebaseFunction('myFatoorahCreateSupplier', { data });
			return result;
		} catch (err) {
			const msg = err?.message || 'Error creating supplier';
			Alert.error(msg);
			console.error(err);
			throw err;
		}
	}

	static async updateSupplier(data) {
		try {
			const result = await callFirebaseFunction('myFatoorahUpdateSupplier', { data });
			return result;
		} catch (err) {
			const msg = err?.message || 'Error updating supplier';
			Alert.error(msg);
			console.error(err);
			throw err;
		}
	}

	static async uploadSupplierDocuments(data) {
		try {
			const result = await callFirebaseFunction('myFatoorahUploadDocuments', { data });
			return result;
		} catch (err) {
			const msg = err?.message || 'Error uploading documents';
			Alert.error(msg);
			console.error(err);
			throw err;
		}
	}

	static async getSupplier() {
		try {
			const result = await callFirebaseFunction('myFatoorahGetSupplier');
			return result?.supplier;
		} catch (err) {
			const msg = err?.message || 'Error fetching supplier';
			Alert.error(msg);
			console.error(err);
			throw err;
		}
	}

	// Additional MyFatoorah API methods based on documentation
	static async createInvoice(data) {
		try {
			const result = await callFirebaseFunction('myFatoorahCreateInvoice', data);
			return result;
		} catch (err) {
			const msg = err?.message || 'Error creating invoice';
			Alert.error(msg);
			console.error(err);
			throw err;
		}
	}

	static async getPaymentStatus(invoiceId) {
		try {
			const result = await callFirebaseFunction('myFatoorahGetPaymentStatus', { invoiceId });
			return result;
		} catch (err) {
			const msg = err?.message || 'Error getting payment status';
			Alert.error(msg);
			console.error(err);
			throw err;
		}
	}

	static async getSupplierDashboard() {
		try {
			const result = await callFirebaseFunction('myFatoorahGetSupplierDashboard');
			return result;
		} catch (err) {
			const message = err.response?.data?.error;
			const msg = message || err?.message || 'Error getting supplier dashboard';
			if (message != 'Supplier not found') {
				Alert.error(msg);
			}
			console.error(err);
			throw err;
		}
	}

	// static async makeRefund(data) {
	// 	try {
	// 		const result = await callFirebaseFunction('myFatoorahMakeRefund', { data });
	// 		return result;
	// 	} catch (err) {
	// 		const msg = err?.message || 'Error processing refund';
	// 		Alert.error(msg);
	// 		console.error(err);
	// 		throw err;
	// 	}
	// }

	// static async getPaymentMethods() {
	// 	try {
	// 		const result = await callFirebaseFunction('myFatoorahGetPaymentMethods');
	// 		return result;
	// 	} catch (err) {
	// 		const msg = err?.message || 'Error fetching payment methods';
	// 		Alert.error(msg);
	// 		console.error(err);
	// 		throw err;
	// 	}
	// }

	// static async executePayment(data) {
	// 	try {
	// 		const result = await callFirebaseFunction('myFatoorahExecutePayment', { data });
	// 		return result;
	// 	} catch (err) {
	// 		const msg = err?.message || 'Error executing payment';
	// 		Alert.error(msg);
	// 		console.error(err);
	// 		throw err;
	// 	}
	// }
}
